import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnMou } from '../organization/organization';
import { SnOrganizationSettings } from './../organization/organization-settings';

export class SnChildOrganization extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public logoUrl: string;

  @Expose()
  public supportUrl: string;

  @Expose()
  @Type(() => SnMou)
  public mou: SnMou;

  @Expose()
  public contactEmail: string;

  @Expose()
  public contactName: string;

  @Expose()
  public contactPhone: string;

  @Expose()
  public settings: SnOrganizationSettings;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
